<template>
  <div>
    <d-row no-gutters class="page-header py-4 mb-2">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <template v-if="isInPopup">
          <h4>Wywiady</h4>
        </template>
        <template v-else>
          <h4>Lista wywiadów:
            <p class="mt-1 mb-0 patient-name">
              {{ patient.name + ' ' + patient.last_name }}
            </p>
          </h4>
        </template>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="success"
          @click.prevent="showAddInterviewPopup(patient.id)"
          :disabled="!loaded">
          <i class="material-icons">add</i>
          Dodaj wywiad
        </d-button>
      </d-col>
    </d-row>
    <table class="table mt-0 mb-0 w-100">
      <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">Data wystawienia</th>
        <th scope="col" class="border-0">Data wizyty</th>
        <th scope="col" class="border-0">Specjalista</th>
        <th scope="col" class="border-0 text-center">Plik</th>
        <th scope="col" class="border-0 text-center">Akcje</th>
      </tr>
      </thead>
      <tbody v-if="loaded">
      <tr
        v-for="(interview, interviewIndex) of interviews"
        :key="'interview-' + interview.id + '-' + interviewIndex">
        <td class="align-middle">
          {{interview.created_at.slice(0, 10)}}
        </td>
        <td class="align-middle">
          <template v-if="interview.visit_date !== 'brak...'">
            <p style="color: #17c671">{{ interview.visit_date.slice(0, 11) }}</p>
            <span style="margin-top: -30px; display: block; font-size: 0.9rem; opacity: 0.6">
                {{ interview.visit_date.slice(11, 16) }} - {{ interview.visit_date.slice(11, 16) }}
              </span>
          </template>
          <template v-else>
            <span style="opacity: 0.5">Brak</span>
          </template>
        </td>
        <td class="align-middle">
          {{ getUserName(interview.user_id) }}
        </td>
        <td class="align-middle text-center">
          <d-button
            theme="info"
            outline
            :disabled="actionInProgress !== false"
            @click.prevent="downloadInterview(interview.id)">
            <template v-if="actionInProgress !== interview.id">
              <i class="material-icons">cloud_download</i>.
              <span v-if="!isInPopup" class="ml-2">Pobierz</span>
            </template>
            <template v-else>
              <div class="spinner-border spinner-border-sm" role="status"></div>
            </template>
          </d-button>
        </td>
        <td
          class="align-middle text-center"
          style="width: 130px;">
          <d-button
            theme="primary"
            @click.prevent="showEditInterviewPopup(interview.id)"
            class="mr-2"
            title="Edytuj">
            <i class="material-icons">edit</i>
          </d-button>
          <d-button
            theme="danger"
            :disabled="removeInProgress"
            @click.prevent="removeInterview(interview.id)"
            title="Usuń">
            <i class="material-icons">delete</i>
          </d-button>
        </td>
      </tr>
      <tr
        v-if="!interviews.length">
        <td
          colspan="6"
          class="text-center">
          Brak wywiadów do wyświetlenia&hellip;
        </td>
      </tr>
      </tbody>
    </table>
    <div v-if="!loaded" class="pb-3 pt-3 text-center">
      Trwa ładowanie danych&hellip;
    </div>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
    </d-alert>

    <patients-form-interviews-popup
      v-if="isShowInterviewsPopup"
      :on-close-popup="handleCloseInterviewPopup"
      :on-submit-callback="loadItemsData"
      :patient-id="patient.id"
      :interview-id="editInterviewID || 0"
      :visit-id="visitId"
      :show="true"/>
  </div>
</template>

<script>
import Vue from 'vue';
import ListUtils from '@/utils/ListUtils.js';
import PatientsFormInterviewsPopup from '@/components/forms/patients/PatientsFormInterviewsPopup.vue';

export default {
  name: 'patients-form-interviews',
  props: {
    allUsers: {
      required: true,
      type: Array
    },
    filterForVisit: {
      default: false,
      type: Boolean
    },
    isInPopup: {
      default: false,
      type: Boolean
    },
    isVisible: {
      default: false,
      type: Boolean
    },
    patient: {
      required: true,
      type: Object
    },
    visitId: {
      default: 0,
      type: Number
    }
  },
  components: {
    'patients-form-interviews-popup': PatientsFormInterviewsPopup,
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue && !this.loaded) {
        this.loadItemsData();
      }
    }
  },
  data () {
    return {
      actionInProgress: false,
      interviews: [],
      editInterviewID: 0,
      isShowInterviewsPopup: false,
      loaded: false,
      loadError: false,
      removeInProgress: false
    }
  },
  mounted () {
    if (this.isVisible) {
      this.loadItemsData();
    }
  },
  methods: {
    loadItemsData () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);

      let where = {};
      if (this.filterForVisit) {
        where.visit_id = this.visitId;
      }

      ListUtils.loadItemsData(this, {
        endpoint: '/patients/interviews/items?patient_id=' + this.patient.id,
        listField: 'interviews',
        pagination: false,
        params: {
          where
        }
      });
    },
    removeInterview (interviewID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/patients/interviews/delete/',
        id: interviewID,
        successTitle: 'Usunięto wywiad',
        successText: 'Wybrany wywiad został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten wywiad?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie wywiadu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadItemsData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    downloadInterview (interviewID) {
      this.actionInProgress = true;

      this.$http.post('/patients/interviews/get-file/' + interviewID, {}, {
        responseType: 'blob'
      }).then(response => {
        // Odczyt nagłówka (działa z axios i vue-resource)
        const disposition = typeof response.headers.get === 'function'
          ? response.headers.get('content-disposition')
          : response.headers['content-disposition'];
        let filename = 'Wywiad-nr-' + interviewID + '.pdf'; // fallback
        if (disposition) {
          const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
          const asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
          if (utf8Match) {
            filename = decodeURIComponent(utf8Match[1]);
          } else if (asciiMatch) {
            filename = asciiMatch[1];
          }
        }
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.addEventListener('click', this.clickCallback, false);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
      }).finally(() => {
        this.actionInProgress = false;
      });
    },
    clickCallback (e) {
      e.stopPropagation();
    },
    getUserName (userID) {
      if (!userID) {
        return 'brak';
      }

      let itemFound = this.allUsers.find(item => item.id === userID);

      if (!itemFound) {
        return 'Nie znaleziono specjalisty';
      }

      return itemFound.name + ' ' + itemFound.last_name;
    },
    showEditInterviewPopup (interviewID) {
      Vue.set(this, 'editInterviewID', interviewID);
      Vue.set(this, 'isShowInterviewsPopup', true);
    },
    showAddInterviewPopup () {
      Vue.set(this, 'editInterviewID', 0);
      Vue.set(this, 'isShowInterviewsPopup', true);
    },
    handleCloseInterviewPopup () {
      Vue.set(this, 'isShowInterviewsPopup', false);
      Vue.set(this, 'editInterviewID', 0);
    }
  }
}
</script>
